import { configureStore } from '@reduxjs/toolkit';
import {
  accountReducer,
  chatReducer,
  coinReducer,
  computerReducer,
  layoutReducer,
  messageReducer,
  newsReducer,
  scheduledTasksReducer,
  validationReducer,
} from './slices';

export const store = configureStore({
  reducer: {
    account: accountReducer,
    chat: chatReducer,
    coin: coinReducer,
    computer: computerReducer,
    layout: layoutReducer,
    message: messageReducer,
    news: newsReducer,
    scheduledTask: scheduledTasksReducer,
    validation: validationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
